export default "/react/card-mobile-4c48dec2.png";